var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'view-all' : _vm.view_all, 'public' : _vm.public_view},attrs:{"id":"vgift-panel-container"}},_vm._l((_vm.gifts),function(gift,index){return _c('VgiftPanelItem',_vm._b({key:index,attrs:{"public_view":_vm.public_view}},'VgiftPanelItem',gift,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }